(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('consignments', {
        templateUrl: 'views/components/views/consignments/consignments.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'consignmentsService', 'logisticService', 'consignmentBatchConsignmentsService', 'deliveryPlanningService', 'rememberService', 'ttGridFactory', 'layoutService', function ($stateParams, stateService, utilityService, consignmentsService, logisticService, consignmentBatchConsignmentsService, deliveryPlanningService, rememberService, ttGridFactory, layoutService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let argType = $stateParams.argtype;
            let argValue = $stateParams.argvalue;
            let onDestroy = [];

            let variableNames = {
                businessco_no_from: '',
                stockplace_id_from: '',
                stocklocation_keyno_trolley: '',
                consignmentshipment_keyno: '',
                date_fom: '',
                date_tom: '',
                dateselector_index: '',
                gb_consignment_status: '',
                filterval: ''
            };

            vm.model = {
                argType: argType,
                gridReady: false,
                tabletSize: layoutService.getMediaQueries().tablet,
                consignmentStatusTabs: {
                    active: 'NOTAPPROVED',
                    buttons: [
                        { id: 'NOTAPPROVED', label: 'gb_consignment_status_not_approved', onClick: () => selectConsignmentStatusTab('NOTAPPROVED') },
                        { id: 'APPROVED', label: 'gb_consignment_status_approved', onClick: () => selectConsignmentStatusTab('APPROVED') },
                        { id: 'ALL', label: 'gb_consignment_status_all', onClick: () => selectConsignmentStatusTab('ALL') },
                    ]
                },
                stockLocationTrolleyButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => reset('stocklocation_keyno_trolley') }
                ],
                consignmentShipmentButtons: [
                    {
                        id: 'new',
                        icon: 'fa fa-solid fa-plus',
                        color: 'primary',
                        type: 'primary',
                        onClick: () => {
                            stateService.go('consignmentshipment', {
                                consignmentshipment_keyno: '0',
                                stockplace_id: vm.model.setting.stockplace_id_from
                            });
                        }
                    },
                    {
                        id: 'list',
                        icon: 'fa fa-solid fa-bars',
                        color: 'primary',
                        type: 'primary',
                        onClick: () => stateService.go('consignmentshipments')
                    }
                ],
                consignmentShipmentButtonsExpanded: [
                    {
                        id: 'erase',
                        icon: 'fa fa-solid fa-eraser',
                        color: 'danger',
                        type: 'danger',
                        onClick: () => reset('consignmentshipment_keyno')
                    },
                    {
                        id: 'new',
                        icon: 'fa fa-solid fa-plus',
                        color: 'primary',
                        type: 'primary',
                        onClick: () => {
                            stateService.go('consignmentshipment', {
                                consignmentshipment_keyno: '0',
                                stockplace_id: vm.model.setting.stockplace_id_from
                            });
                        }
                    },
                    {
                        id: 'list',
                        icon: 'fa fa-solid fa-bars',
                        color: 'primary',
                        type: 'primary',
                        onClick: () => stateService.go('consignmentshipments')
                    },
                    {
                        id: 'goto',
                        icon: 'fa fa-solid fa-chevron-right',
                        color: 'primary',
                        type: 'primary',
                        onClick: () => {
                            if (vm.model.setting.consignmentshipment_keyno > 0) {
                                stateService.go('consignmentshipment', {
                                    consignmentshipment_keyno: vm.model.setting.consignmentshipment_keyno,
                                    stockplace_id: vm.model.setting.stockplace_id_from
                                });
                            }
                        }
                    }
                ],
                filterButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => reset('filterval') }
                ],
                setting: {},
                selectListCompanies: [],
                selectListStockPlaces: [],
                selectListTrolleys: [],
                selectListConsignmentShipments: [],
                itemsListConsignments: []
            };

            vm.grid = new ttGridFactory({
                rememberId: 'consignments.grid',
                kendo: {
                    height: '100%',
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            });

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE CALLS
            
            async function loadSetting() {
                vm.model.setting = (await consignmentsService.getSetting({
                    argtype: argType,
                    argvalue: argValue
                }))[0];

                vm.model.consignmentStatusTabs.active = vm.model.setting.gb_consignment_status;

                Promise.all([
                    loadStockPlaces(),
                    loadTrolleys(),
                    loadConsignmentShipments(),
                    retrieveBusinessChanged(),
                    retrieveCurrentTrolley()
                ]).then(() => {
                    if (vm.model.tabletSize.matches === false) {
                        loadConsignments();
                    } else {
                        loadGrid();
                    }

                    Promise.resolve();
                });
            }

            async function loadCompanies() {
                vm.model.selectListCompanies = await logisticService.listCompanies();
            }

            async function loadStockPlaces() {
                if (utilityService.validateParmsValue(vm.model.setting.businessco_no_from) !== true) return;

                vm.model.selectListStockPlaces = await logisticService.listStocks({ businessco_no: vm.model.setting.businessco_no_from });
            }

            async function loadTrolleys() {
                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id_from) !== true) return;

                vm.model.selectListTrolleys = await logisticService.listTrolleys({
                    stockplace_id: vm.model.setting.stockplace_id_from,
                    addall: '1'
                });
            }

            async function loadConsignmentShipments() {
                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id_from) !== true) return;

                vm.model.selectListConsignmentShipments = await deliveryPlanningService.listConsignmentShipments({
                    stockplace_id: vm.model.setting.stockplace_id_from,
                    add_all: '1',
                    add_none: '1'
                });
            }

            async function retrieveBusinessChanged() {
                if (utilityService.validateParmsValue(vm.model.setting.businessco_no_from) !== true) return;

                const response = await consignmentsService.getBusinessChanged({ businessco_no_from: vm.model.setting.businessco_no_from });

                vm.model.setting.stockplace_id_from = response[0].stockplace_id_from;
            }

            async function retrieveCurrentTrolley() {
                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id_from) !== true) return;

                const response = await consignmentsService.getStockPlaceChanged({ stockplace_id_from: vm.model.setting.stockplace_id_from });

                vm.model.setting.stocklocation_keyno_trolley = response[0].stocklocation_keyno_trolley;
                vm.model.setting.consignmentshipment_keyno = response[0].consignmentshipment_keyno;
            }

            async function loadConsignments() {
                if (utilityService.validateParmsValue(vm.model.setting.businessco_no_from) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id_from, true) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.stocklocation_keyno_trolley, true) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.date_fom) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.date_tom) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.gb_consignment_status) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.consignmentshipment_keyno, true) !== true) return;

                vm.model.itemsListConsignments = await consignmentBatchConsignmentsService.listConsignments({
                    argtype: argType,
                    argvalue: argValue,
                    businessco_no_from: vm.model.setting.businessco_no_from,
                    stockplace_id_from: vm.model.setting.stockplace_id_from,
                    stocklocation_keyno_trolley: vm.model.setting.stocklocation_keyno_trolley,
                    date_fom: vm.model.setting.date_fom,
                    date_tom: vm.model.setting.date_tom,
                    gb_consignment_status: vm.model.setting.gb_consignment_status,
                    consignmentshipment_keyno: vm.model.setting.consignmentshipment_keyno
                });
            }

            // #endregion LOAD PROCEDURE CALLS

            // #region GRID PROCEDURE FUNCTION CALLS

            async function loadGrid() {
                vm.grid.dataTask.loadData = {
                    method: 3444,
                    parameters: {
                        argtype: argType,
                        argvalue: argValue,
                        businessco_no_from: vm.model.setting.businessco_no_from,
                        stockplace_id_from: vm.model.setting.stockplace_id_from,
                        stocklocation_keyno_trolley: vm.model.setting.stocklocation_keyno_trolley,
                        date_fom: vm.model.setting.date_fom,
                        date_tom: vm.model.setting.date_tom,
                        gb_consignment_status: vm.model.setting.gb_consignment_status,
                        consignmentshipment_keyno: vm.model.setting.consignmentshipment_keyno
                    }
                };

                vm.model.gridReady = true;

                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
            }

            // #endregion GRID PROCEDURE FUNCTION CALLS

            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            function rememberFunc(id) {
                Object.keys(variableNames).forEach((key) => {
                    switch (key) {
                        case 'businessco_no_from':
                        case 'date_fom':
                        case 'date_tom':
                        case 'dateselector_index':
                        case 'gb_consignment_status':
                        case 'filterval':
                            variableNames[key] = stateService.getCurrentName() + '.' + key;
                            break;
                        case 'stocklocation_keyno_trolley':
                        case 'consignmentshipment_keyno':
                            variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key + '.' + 'stockplace_id' + '=' + vm.model.setting.stockplace_id_from;
                            break;
                        case 'stockplace_id_from':
                            variableNames[key] = stateService.getCurrentName() + '.' + key + '.' + 'businessco_no_from' + '=' + vm.model.setting.businessco_no_from;
                            break;
                        default:
                            variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
                            break;
                    }
                });

                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

                let variableValue = null;

                switch (id) {
                    case 'businessco_no_from':
                    case 'stockplace_id_from':
                    case 'date_fom':
                    case 'date_tom':
                    case 'dateselector_index':
                    case 'gb_consignment_status':
                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

                        variableValue = vm.model.setting[id];
                        break;
                    case 'stocklocation_keyno_trolley':
                    case 'consignmentshipment_keyno':
                    case 'filterval':
                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

                        variableValue = vm.model.setting[id];
                        break;
                    default:
                        break;
                }

                return rememberService.remember(variableNames[id], variableValue);
            }

            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            // #region RESET BUTTON FUNCTION

            function reset(id) {
                switch (id) {
                    case 'stocklocation_keyno_trolley':
                        vm.model.setting.stocklocation_keyno_trolley = '0';

                        if (vm.model.setting.stocklocation_keyno_trolley === '0') {
                            Promise.all([
                                rememberFunc('stocklocation_keyno_trolley')
                            ]).then(() => {
                                if (vm.model.tabletSize.matches === false) {
                                    loadConsignments();
                                } else {
                                    loadGrid();
                                }

                                Promise.resolve();
                            });
                        }
                        break;
                    case 'consignmentshipment_keyno':
                        vm.model.setting.consignmentshipment_keyno = '0';

                        if (vm.model.setting.consignmentshipment_keyno === '0') {
                            rememberFunc('consignmentshipment_keyno');

                            if (vm.model.tabletSize.matches === false) {
                                loadConsignments();
                            } else {
                                loadGrid();
                            }
                        }
                        break;
                    case 'filterval':
                        vm.model.setting.filterval = '';

                        if (vm.model.setting.filterval === '') rememberFunc('filterval');
                        break;
                    default:
                        break;
                }
            }

            // #endregion RESET BUTTON FUNCTION

            // #region BUTTON RADIO FUNCTION

            function selectConsignmentStatusTab(id) {
                vm.model.consignmentStatusTabs.active = id;
                vm.model.setting.gb_consignment_status = vm.model.consignmentStatusTabs.active;

                rememberFunc('gb_consignment_status');

                if (vm.model.tabletSize.matches === false) {
                    loadConsignments();
                } else {
                    loadGrid();
                }
            }

            // #endregion BUTTON RADIO FUNCTION

            // #region FIELD DATE RANGE CHANGE FUNCTION

            vm.onDateRangeChanged = function (startDate, endDate, dateInterval) {
                vm.model.setting.date_fom = startDate;
                vm.model.setting.date_tom = endDate;
                vm.model.setting.dateselector_index = dateInterval;

                if (vm.model.setting.date_fom) rememberFunc('date_fom');
                if (vm.model.setting.date_tom) rememberFunc('date_tom');
                if (vm.model.setting.dateselector_index) rememberFunc('dateselector_index');

                if (vm.model.tabletSize.matches === false) {
                    loadConsignments();
                } else {
                    loadGrid();
                }
            }

            // #endregion FIELD DATE RANGE CHANGE FUNCTION

            // #region FIELD CHANGE FUNCTIONS

            // Virksomhet
            vm.onBusinessCompanyFromChanged = async function (value) {
                vm.model.setting.businessco_no_from = value;

                Promise.all([
                    rememberFunc('businessco_no_from'),
                    loadStockPlaces(),
                    retrieveBusinessChanged()
                ]).then(() => {
                    if (vm.model.tabletSize.matches === false) {
                        loadConsignments();
                    } else {
                        loadGrid();
                    }

                    Promise.resolve();
                });
            }

            // Lagersted
            vm.onStockplaceFromChanged = async function (value) {
                vm.model.setting.stockplace_id_from = value;

                Promise.all([
                    rememberFunc('stockplace_id_from'),
                    loadConsignmentShipments(),
                    loadTrolleys(),
                    retrieveCurrentTrolley()
                ]).then(() => {
                    if (vm.model.tabletSize.matches === false) {
                        loadConsignments();
                    } else {
                        loadGrid();
                    }

                    Promise.resolve();
                });
            }

            // Plukker
            vm.onStocklocationTrolleyChanged = function (value) {
                vm.model.setting.stocklocation_keyno_trolley = value;

                Promise.all([
                    rememberFunc('stocklocation_keyno_trolley')
                ]).then(() => {
                    if (vm.model.tabletSize.matches === false) {
                        loadConsignments();
                    } else {
                        loadGrid();
                    }

                    Promise.resolve();
                });
            }

            // Transport
            vm.onConsignmentShipmentChanged = function (value) {
                vm.model.setting.consignmentshipment_keyno = value;

                Promise.all([
                    rememberFunc('consignmentshipment_keyno')
                ]).then(() => {
                    if (vm.model.tabletSize.matches === false) {
                        loadConsignments();
                    } else {
                        loadGrid();
                    }

                    Promise.resolve();
                });
            }

            // #endregion FIELD CHANGE FUNCTIONS

            // #region FIELD BLUR FUNCTION

            vm.onFilterValueBlur = function (value) {
                rememberFunc('filterval');
            }

            // #endregion FIELD BLUR FUNCTION

            // #region ON WINDOW RESIZE FUNCTION

            async function onWindowResize() {
                if (vm.model.tabletSize.matches === false) {
                    loadConsignments();
                } else {
                    loadGrid();
                }
            }

            // #endregion ON WINDOW RESIZE FUNCTION

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                loadSetting();
                loadCompanies();

            	window.addEventListener('resize', onWindowResize);
            	onWindowResize();
            };

            // #endregion ON INIT FUNCTION

            // #region DESTROY FUNCTION

            vm.$onDestroy = function () {
            	window.removeEventListener('resize', onWindowResize);

                onDestroy.forEach((fn) => {
                    if (typeof fn === 'function') fn();
            	});
            };

            // #endregion DESTROY FUNCTION

        }]
    });
})();
